import { Component, OnInit, Inject } from '@angular/core';

import { SalesService } from 'src/app/services/sales.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-change-commission-report-status',
  templateUrl: './change-commission-report-status.component.html',
  styleUrls: ['./change-commission-report-status.component.css']
})
export class ChangeCommissionReportStatusComponent implements OnInit {
  public changescreportForm: UntypedFormGroup;
  api_error: any;
  api_success: string;
  rep_status: string;
  statusTo: string;
  disableConfirmbtn = false;
  commReportId: any;
  reportDetails: any;
  scConfig: any = {};
  btnDisabled = true;
  commissionStatus: any = [];
  constructor(private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: any,
     private formbuilder: UntypedFormBuilder,
     private commonfilterService: CommonfilterService,
      private salesService: SalesService) {
        this.commonfilterService.getConfigData()
      .subscribe(res => {
        this.scConfig = res;
        console.log(this.scConfig);
        this.commissionStatus = this.scConfig.scComReportStatusDetails;
      });
       }

  ngOnInit() {
    this.reportDetails = this.data;
    console.log(this.reportDetails.commission.reportStatus);
    console.log(this.reportDetails.reportStatus);
    this.commReportId = this.data['commission'].commReportId;
    if (this.rep_status === 'ACTIVE') {
      this.statusTo = 'INACTIVE';
    } else {
      this.statusTo = 'ACTIVE';
    }
    this.changescreportForm = this.formbuilder.group({
      invoiceChangeStatus: ''
    });
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    this.salesService.changeCommissionReportStatus(this.commReportId, this.changescreportForm.value.invoiceChangeStatus)
    .subscribe(
      data => {
        this.api_success = 'Status changed Successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
          }, 2000);
        },
     (error) => {
      this.disableConfirmbtn = false;
      this.api_error = error.error;
      }
    );

  }
  radioChange() {
    console.log(this.changescreportForm.get('invoiceChangeStatus').value);
 if ( (this.changescreportForm.get('invoiceChangeStatus').value) !== ' ' ) {
  this.btnDisabled = false;
 } else {
  this.btnDisabled = true;
 }

 }
}
// /rest/mgmt/sc/commission/{comReportId}/{status}

